import React from "react"

import SelectTags from "../../common/tags/SelectTags"

const userStatuses = [
    {
        label: "Active",
        value: "Active"
    },
    {
        label: "Inactive",
        value: "Inactive"
    }
]

const UserFilterForm = ({
    model,
    onEventChange,
    onValueChange,
    onCommunitiesSearch
}) => (
    <form name="filterform">
        <div className="filter-block">
            <label>First Name</label>
            <input
                id="user-filter-first-name"
                type="text"
                className="form-control"
                name="first_name"
                value={model.first_name}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label>Last Name</label>
            <input
                id="user-filter-last-name"
                type="text"
                className="form-control"
                name="last_name"
                value={model.last_name}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label>Status</label>
            <select
                className="form-control"
                name="status"
                value={model.status}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {userStatuses.map(({ label, value }) => (
                    <option value={value} key={value}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label>Communities</label>
            <SelectTags
                name="including_communities"
                value={model.including_communities}
                loadOptions={onCommunitiesSearch}
                placeholder="Communities"
                onChange={onValueChange("including_communities")}
            />
        </div>
    </form>
)

export default UserFilterForm
